import { createAsyncThunk } from '@reduxjs/toolkit';
import { subscriptionsApi } from '../../api/subscriptionsApi/subscriptionsApi';

// Get all subscription plans
export const getSubscriptionPlansAsyncThunk = createAsyncThunk(
  'subscription/getSubscriptionPlans',
  async (params, { rejectWithValue }) => {
    try {
      const response = await subscriptionsApi.getSubscriptionPlans(params);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch subscription plans'
      );
    }
  }
);

// Get subscription plan by ID
export const getSubscriptionPlanByIdAsyncThunk = createAsyncThunk(
  'subscription/getSubscriptionPlanById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await subscriptionsApi.getSubscriptionPlanById(id);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch subscription plan'
      );
    }
  }
);

// Create subscription plan
export const createSubscriptionPlanAsyncThunk = createAsyncThunk(
  'subscription/createSubscriptionPlan',
  async (subscriptionData, { rejectWithValue }) => {
    try {
      const response = await subscriptionsApi.createSubscriptionPlan(subscriptionData);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to create subscription plan'
      );
    }
  }
);

// Update subscription plan
export const updateSubscriptionPlanAsyncThunk = createAsyncThunk(
  'subscription/updateSubscriptionPlan',
  async ({ id, subscriptionData }, { rejectWithValue }) => {
    try {
      const response = await subscriptionsApi.updateSubscriptionPlan(id, subscriptionData);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to update subscription plan'
      );
    }
  }
);

// Delete subscription plan
export const deleteSubscriptionPlanAsyncThunk = createAsyncThunk(
  'subscription/deleteSubscriptionPlan',
  async (id, { rejectWithValue }) => {
    try {
      const response = await subscriptionsApi.deleteSubscriptionPlan(id);
      return id; // Return the ID of the deleted plan
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to delete subscription plan'
      );
    }
  }
);
